import React from 'react';
import Box from '@mui/material/Box';
import InfoRow from '../common/InfoRow';
import { DeviceSwitchPortsDataType } from '../../../types/buildingTypes';
import dialogStyles from '../common/dialogStyles';

interface PortBounceFormProps {
  selectedPorts: DeviceSwitchPortsDataType[];
}

const PortBounceForm: React.FC<PortBounceFormProps> = ({ selectedPorts }) => {
  return (
    <>
      <Box
        sx={{
          ...dialogStyles.gridStyles,
          gridTemplateColumns: selectedPorts.length > 1 ? '1fr 1fr' : '1fr',
        }}
      >
        {selectedPorts.map((entity, index) => (
          <Box key={index}>
            <InfoRow label={entity.port} value={`(VLAN: ${entity.vlan})`} />
          </Box>
        ))}
      </Box>
    </>
  );
};

export default PortBounceForm;
